import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import FreeTrialModal from './FreeTrialModal/FreeTrialModal'
import FreeTrialPaymentModal from './FreeTrialPaymentModal/FreeTrialPaymentModal'
import FreeTrialBanner from './FreeTrialBanner/FreeTrialBanner'
import useFreeTrialModal from '../../hooks/useFreeTrialModal'
import { PLANS, getMergedPlan } from '../../constants/plans'
import { fetchUserData, showMessageModal } from '../../Manage/actions'
import { hasPreviewModeProject } from '../../utils/free-trial'

const STAGE_AD = 'STAGE_AD'
const STAGE_PAY = 'STAGE_PAY'

const FreeTrialModalContainer = ({
  userProfile,
  liveSites,
  dispatch,
  setFirstTimeSuccModal,
  shouldShowOnUploadUpdate = false,
  hideBanner = false,
  previewData
}) => {
  const [selectedPlan, setSelectedPlan] = useState(null)
  const history = useHistory()
  const [stage, setStage] = useState(STAGE_AD)
  const isInPreviewMode = hasPreviewModeProject(liveSites, previewData)

  const {
    showModal,
    setShowModal,
    showPaymentModal,
    handleStartTrial,
    handleSkipTrial,
    handlePaymentModalClose,
    planType,
    setPlanType,
    preventSkip
  } = useFreeTrialModal(userProfile, liveSites, dispatch, setFirstTimeSuccModal, shouldShowOnUploadUpdate, previewData)

  const startTrial = () => {
    setStage(STAGE_PAY)
    handleStartTrial()
  }

  const handleOpenFreeTrialModal = (planType) => {
    if (isInPreviewMode) return
    setPlanType(planType)
    setStage(STAGE_AD)
    setShowModal(true)
  }

  const isFirstTimeUpload = localStorage.getItem('isFirstTimeUpload') === 'true'

  useEffect(() => {
    const targetPlanId = planType === 'solo' ? PLANS.PRO.id : PLANS.PRO_U.id
    setSelectedPlan(getMergedPlan(targetPlanId, userProfile?.currency))
  }, [userProfile?.currency, planType])

  const onCurrencySelected = (currency) => {
    setSelectedPlan(getMergedPlan(selectedPlan.id, currency))
  }

  const handleFreeTrialSuccess = () => {
    handlePaymentModalClose()
    localStorage.removeItem('isFirstTimeUpload')
    localStorage.setItem('hasCompletedFreeTrial', 'true')

    localStorage.setItem('freeTrialModalDismissedForUpload', 'true')

    if (shouldShowOnUploadUpdate) {
      return
    }

    history.replace({ pathname: '/manage' })
    if (isFirstTimeUpload && liveSites && liveSites.length === 1) {
      const firstSite = liveSites[0]
      dispatch(setFirstTimeSuccModal({ showFistTimeSuccModal: true, firstTimeSite: firstSite }))
    } else {
      const planName = planType === 'solo' ? 'Solo' : 'Pro'
      const trialDays = 7
      dispatch(
        showMessageModal({
          title: 'Free Trial Activated',
          message: `Your ${trialDays}-day ${planName} plan free trial has begun successfully.`,
          success: true
        })
      )
      dispatch(fetchUserData(false))

      if (window.oaiq) window.oaiq('measure', 'trial_started', { type: 'plan_enrollment' })
    }
  }

  return (
    <>
      {!isInPreviewMode && !hideBanner && (
        <FreeTrialBanner
          userCategory={userProfile?.userCategory}
          productId={userProfile?.productId}
          liveSites={liveSites}
          onOpenFreeTrialModal={handleOpenFreeTrialModal}
        />
      )}

      {!isInPreviewMode && showModal && stage === STAGE_AD && (
        <FreeTrialModal
          show={showModal}
          onHide={() => {
            if (preventSkip) return
            handleSkipTrial()
          }}
          onStartTrial={startTrial}
          onSkip={() => {
            if (preventSkip) return
            handleSkipTrial()
          }}
          loading={false}
          planType={planType}
          hideSkip={preventSkip}
        />
      )}

      {!isInPreviewMode && showPaymentModal && stage === STAGE_PAY && (
        <FreeTrialPaymentModal
          show={showPaymentModal}
          onHide={() => {
            if (preventSkip) return
            handlePaymentModalClose()
          }}
          plan={selectedPlan}
          email={userProfile?.email}
          periodProp="monthly"
          source={planType === 'solo' ? 'solo_free_trial' : 'free_trial'}
          onCurrencySelected={onCurrencySelected}
          onFreeTrialSuccess={handleFreeTrialSuccess}
          studentData={{}}
          accountCreated={userProfile?.created}
          isFreeTrail={true}
          allowB2C={planType === 'solo'}
          userProfile={userProfile}
          planType={planType}
          hideClose={preventSkip}
        />
      )}
    </>
  )
}

export default FreeTrialModalContainer
